<template>
  <md-dialog v-bind="$attrs" v-on="$listeners" :md-fullscreen="false">
    <div class="viewport">
      <md-toolbar md-elevation="1">
        <span v-if="mdBarcodes.length > 1" class="md-title">Штрихкоды</span>
        <span v-else class="md-title">Штрихкод</span>
      </md-toolbar>
      <md-content class="barcodes-scroll md-scrollbar">
        <md-card v-for="barcode in mdBarcodes" :key="barcode">
          <md-card-content>
            <barcode
              tag="img"
              :value="barcode"
              :options="{ displayValue: true, format: 'EAN13' }"
            ></barcode>
          </md-card-content>
        </md-card>
      </md-content>
    </div>

    <md-dialog-actions>
      <md-button class="md-primary" @click="$emit('update:mdActive', false)">
        {{ mdConfirmText }}
      </md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
  export default {
    name: "MdDialogAlertBarcode",
    props: {
      mdBarcodes: Array,
      mdConfirmText: {
        type: String,
        default: "Ok",
      },
    },
  };
</script>

<style lang="scss" scoped>
  .barcodes-scroll {
    max-height: 600px;
    overflow: auto;
  }
</style>
